'use client';
import { useTranslations } from 'next-intl';
import { CatHeading } from 'components/blocks-components';
import { MyEquipmentHeader } from 'components/pcc-components';
import { useMyEquipmentDrawer } from '../my-equipment-drawer-context';
import { useFeedback } from 'providers/feedback-provider';

export const DeleteEquipmentDrawerHeader = () => {
  const t = useTranslations();
  const {
    deleteEquipmentDrawer: { closeDrawer, isChild }
  } = useMyEquipmentDrawer();
  const { dismissFeedback } = useFeedback();
  const closeDrawersAndDismissFeedback = () => {
    dismissFeedback();
    closeDrawer();
  };

  return (
    <MyEquipmentHeader
      variant={'title-sm'}
      className="d-flex"
      onBackButtonClick={isChild ? closeDrawersAndDismissFeedback : null}
    >
      <CatHeading variant="title-sm">{t('DELETE_EQUIPMENT')}</CatHeading>
    </MyEquipmentHeader>
  );
};
